(function($) {
	'use strict';
	$.fn.Collection__Rename = function() {
		this.each(function() { 
			
			/*
			 * Action: Rename Collection
			 */
			var $self = $(this);
			
			$('#rename-collection').off('submit.rename-collection').on('submit.rename-collection', function(e) {
				e.preventDefault();
				
				// Sets listeners on $self
				$.Globals.overlayNotify( $self, Front.translations.saving, Front.translations.collection_saved );
				
				// Do update
				$.Globals.ajax( 'scspaces_update_collection_title', { ctitle: $self.val(), cid: $self.data('cid') }, function( data ) {
					
					if( data.success ) {
	
						// Track in Google
						$.Globals.track_event( 'Collection Renamed' );
						
						// Update main title
						$('h4.collection-title').empty().html( $self.val() );
						
						// Listen for complete to close overlay then trigger success message
						$self.trigger('overlay-notify-success');
						
	
					}
				});
		
			});
			
		
		});
		return this;
	};
}(jQuery));